import { log } from '@domgen/shared/utils/log';
import { ModelNumberLookupResponse } from '@domgen/shared/models/services/api/applianceLookup';
import { get } from './client';

export const queryModelNumber = async (
  modelNumber: string,
  signal?: AbortSignal,
): Promise<ModelNumberLookupResponse> => {
  const brandCode = import.meta.env.VITE_BRAND_CODE;
  try {
    return await get<ModelNumberLookupResponse>(
      `/v1/appliance-lookup?brandCode=${brandCode}&modelNumber=${modelNumber}`,
      { signal },
    );
  } catch (error: unknown) {
    if (error instanceof Error) {
      log.error({ message: `Error querying model number: ${error.message}` });
    } else {
      log.error({ message: 'Unknown error querying model number' });
    }
    return { appliances: [] };
  }
};
